module.exports = __webpack_public_path__ + "static/media/iconGallery.8f35a07b.svg";